import { CommonEnums } from 'src/app/shared/common.enums';

export class MJnr_Inst_Cnd {
    mJnr_Inst_Cnd_Id: number;
    mJnr_Inst_Id: number;
    dxMp_Id: number;
    jnrType: string;
    secObjId: number;
    jnrCnd: string;
    valid_Cd: string;
    srt_Order: number;
    attr_Id: number;

    constructor() {
        this.setDefaults()
    }

    setDefaults(): void {
        this.mJnr_Inst_Cnd_Id = CommonEnums.defaults.LONG_VAL;
        this.mJnr_Inst_Id = CommonEnums.defaults.LONG_VAL;
        this.jnrType = CommonEnums.defaults.STRING_EMPTY;
        this.secObjId = CommonEnums.defaults.LONG_VAL;
        this.jnrCnd = CommonEnums.defaults.STRING_EMPTY;
        this.valid_Cd = CommonEnums.defaults.DEFAULT_VALID_CD_VAL;
        this.srt_Order = CommonEnums.defaults.LONG_VAL;
        this.attr_Id = CommonEnums.defaults.LONG_VAL;
        this.dxMp_Id = CommonEnums.defaults.LONG_VAL;
    }

    static parse(mJnr_Inst_CndTmp: MJnr_Inst_Cnd): MJnr_Inst_Cnd {
        let mJnr_Inst_Cnd: MJnr_Inst_Cnd = new MJnr_Inst_Cnd();
        mJnr_Inst_Cnd.copyFrom(mJnr_Inst_CndTmp);
        return mJnr_Inst_Cnd;
    }

    getPrimaryKey(): string {
        return this.dxMp_Id + '.' + this.mJnr_Inst_Id + '.' + this.mJnr_Inst_Cnd_Id;
    }

    copy(): MJnr_Inst_Cnd {
        let mJnr_Inst_CndTmp: MJnr_Inst_Cnd = new MJnr_Inst_Cnd();

        mJnr_Inst_CndTmp.mJnr_Inst_Cnd_Id = this.mJnr_Inst_Cnd_Id;
        mJnr_Inst_CndTmp.mJnr_Inst_Id = this.mJnr_Inst_Id;
        mJnr_Inst_CndTmp.jnrType = this.jnrType;
        mJnr_Inst_CndTmp.secObjId = this.secObjId;
        mJnr_Inst_CndTmp.jnrCnd = this.jnrCnd;
        mJnr_Inst_CndTmp.valid_Cd = this.valid_Cd;
        mJnr_Inst_CndTmp.srt_Order = this.srt_Order;
        mJnr_Inst_CndTmp.attr_Id = this.attr_Id;
        mJnr_Inst_CndTmp.dxMp_Id = this.dxMp_Id;

        return mJnr_Inst_CndTmp;
    }

    copyFrom(mJnr_Inst_CndTmp: MJnr_Inst_Cnd): void {
        this.mJnr_Inst_Cnd_Id = mJnr_Inst_CndTmp.mJnr_Inst_Cnd_Id;
        this.mJnr_Inst_Id = mJnr_Inst_CndTmp.mJnr_Inst_Id;
        this.jnrType = mJnr_Inst_CndTmp.jnrType;
        this.secObjId = mJnr_Inst_CndTmp.secObjId;
        this.jnrCnd = mJnr_Inst_CndTmp.jnrCnd;
        this.valid_Cd = mJnr_Inst_CndTmp.valid_Cd;
        this.srt_Order = mJnr_Inst_CndTmp.srt_Order;
        this.attr_Id = mJnr_Inst_CndTmp.attr_Id;
        this.dxMp_Id = mJnr_Inst_CndTmp.dxMp_Id;
    }

    compare(mJnr_Inst_CndTmp: MJnr_Inst_Cnd): string {
        let mJnr_Inst_CndString: string = this.toString(false);
        let mJnr_Inst_CndTmpString: string = mJnr_Inst_CndTmp.toString(false);

        if (mJnr_Inst_CndString != mJnr_Inst_CndTmpString) {
            return mJnr_Inst_CndString + ', ' + mJnr_Inst_CndTmpString;
        }

        return '';
    }

    toString(isNotCompare: boolean = true): string {
        let str: string = "MJnr_Inst_Cnd [mJnr_Inst_Cnd_Id=" + this.mJnr_Inst_Cnd_Id + ", mJnr_Inst_Id=" + this.mJnr_Inst_Id +
            ", jnrType=" + this.jnrType + ", secObjId=" + this.secObjId + ", jnrCnd=" + this.jnrCnd + ", valid_Cd=" + this.valid_Cd +
            ", srt_Order=" + this.srt_Order + ", attr_Id=" + this.attr_Id + ", dxMp_Id=" + this.dxMp_Id;

        if (isNotCompare) {
            str += ''
        }

        str += ']';

        return str;
    }
}